/** Accessible name of a classes trigger: the selected labels, comma-joined; `undefined` when none. */
export function getClassesAriaLabel(
    classes: ReadonlyArray<{ label: string }>,
): string | undefined {
    return classes.map((classItem) => classItem.label).join(", ") || undefined;
}
